/**
 * SmtpSetting(送信元)関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'
import OptionState from './OptionState'

class AccountTitleDetailOptionState extends Record(OptionState) {
  mergeModel(model) {
    return this.merge({
      label: `[${model.account_title_name}]${model.name}`,
      value: model.id
    })
  }
}

export default AccountTitleDetailOptionState
